import React, { useState } from 'react';
import useAPI from '../../hooks/useAPI';
import endpoints from '../../Services/endpointUser';

function AboutUser() {
  const [selectedLembaga, setSelectedLembaga] = useState('');
  const donaturEndpoint = selectedLembaga ? endpoints.donatur.getByLembaga(selectedLembaga) : '/api/donatur';
  const { data, loading, error } = useAPI(donaturEndpoint);
  const { data: lembagaList, loading: lembagaLoading, error: lembagaError } = useAPI(endpoints.lembaga.getAll);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-blue-100 w-full max-w-md text-center space-y-3">
          <div className="animate-spin h-10 w-10 border-b-2 border-blue-900 rounded-full mx-auto"></div>
          <p className="text-blue-900 font-semibold text-xs">Memuat informasi tentang kami...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="bg-red-50 border border-red-200 rounded-2xl p-6 max-w-md text-center">
          <p className="text-red-600 text-xs font-semibold">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 text-blue-900 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">

        {/* Header Hero Banner */}
        <div className="relative overflow-hidden bg-gradient-to-r from-blue-950 via-blue-900 to-blue-900 rounded-3xl p-8 md:p-10 text-white shadow-md border border-blue-900 flex flex-col justify-between gap-4">
          <div className="max-w-3xl space-y-3">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-amber-400/20 text-amber-300 border border-amber-400/30 backdrop-blur-md">
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
              MPZ DT • Profil Lembaga
            </span>
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">
              Daarut Tauhid
            </h1>
            <p className="text-xs md:text-sm text-amber-100 leading-relaxed">
              Lembaga Amil Zakat & filantropi Islam terpercaya yang berkomitmen mengelola zakat, infak, sedekah, dan donasi sosial secara amanah, akuntabel, dan tepat sasaran.
            </p>
          </div>
        </div>

        {/* Profil Singkat */}
        <div className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm space-y-4">
          <span className="text-[11px] font-bold tracking-wider uppercase text-blue-700 bg-blue-50 px-3 py-1 rounded-full border border-blue-100 inline-block">
            Tentang DT Peduli
          </span>
          <h2 className="text-xl md:text-2xl font-bold text-blue-900">
            Berbagi untuk Kemanusiaan dan Pemberdayaan Umat
          </h2>
          <p className="text-xs md:text-sm text-slate-700 leading-relaxed">
            DT Peduli adalah program sosial di bawah naungan Yayasan Kunci Kemurnian Sejahtera yang berfokus pada penyaluran zakat, infak, sedekah, dan donasi kemanusiaan untuk membantu masyarakat rentan dan penerima manfaat (asnaf).
          </p>
          <p className="text-xs md:text-sm text-slate-600 leading-relaxed">
            Melalui layanan zakat digital, program qurban, beasiswa pendidikan tahfidz, bantuan usaha mikro, serta kebencanaan, kami menjalankan setiap amanah donatur secara profesional dan transparan.
          </p>
        </div>

        {/* Visi & Misi */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-3xl border border-blue-100 p-6 shadow-sm space-y-3">
            <span className="text-[10px] font-bold uppercase tracking-wider text-blue-700 bg-blue-50 px-2.5 py-0.5 rounded border border-blue-100">
              Prinsip Utama
            </span>
            <h3 className="text-lg font-bold text-blue-900">Visi Lembaga</h3>
            <p className="text-xs sm:text-sm text-slate-700 leading-relaxed">
              Menjadi lembaga zakat dan filantropi terpercaya, amanah, dan profesional yang mampu memberdayakan masyarakat secara berkelanjutan.
            </p>
          </div>

          <div className="bg-white rounded-3xl border border-amber-200/80 p-6 shadow-sm space-y-3">
            <span className="text-[10px] font-bold uppercase tracking-wider text-amber-800 bg-amber-50 px-2.5 py-0.5 rounded border border-amber-200">
              Komitmen Kerja
            </span>
            <h3 className="text-lg font-bold text-blue-900">Misi Utama</h3>
            <ul className="space-y-2 text-xs text-slate-700">
              <li className="flex items-start gap-2">
                <span className="text-amber-600 font-bold">•</span>
                <span>Mengelola zakat, infak, dan sedekah dengan sistem terpadu dan transparan.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 font-bold">•</span>
                <span>Menyalurkan bantuan tepat sasaran bagi 8 asnaf penerima zakat.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 font-bold">•</span>
                <span>Mendorong kemandirian ekonomi dhuafa melalui pemberdayaan usaha mikro.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-amber-600 font-bold">•</span>
                <span>Mendukung sarana pendidikan, beasiswa santri, dan tanggap bencana.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Informasi Layanan Zakat */}
        <div className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm space-y-6">
          <h2 className="text-lg font-bold text-blue-900">Manfaat & Pengelolaan Zakat</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-blue-50/50 rounded-2xl p-4 border border-blue-100 space-y-1">
              <p className="text-xs font-bold text-blue-900">Spiritual</p>
              <p className="text-[11px] text-slate-600 leading-relaxed">Membersihkan harta dan menyucikan jiwa dari sifat kikir.</p>
            </div>
            <div className="bg-amber-50/50 rounded-2xl p-4 border border-amber-200/80 space-y-1">
              <p className="text-xs font-bold text-amber-900">Sosial</p>
              <p className="text-[11px] text-slate-600 leading-relaxed">Mengurangi angka kesenjangan dan mendukung dhuafa.</p>
            </div>
            <div className="bg-blue-50/50 rounded-2xl p-4 border border-blue-100 space-y-1">
              <p className="text-xs font-bold text-blue-900">Ekonomi</p>
              <p className="text-[11px] text-slate-600 leading-relaxed">Meningkatkan kemandirian usaha mikro masyarakat.</p>
            </div>
            <div className="bg-amber-50/50 rounded-2xl p-4 border border-amber-200/80 space-y-1">
              <p className="text-xs font-bold text-amber-900">Ukhuwah</p>
              <p className="text-[11px] text-slate-600 leading-relaxed">Mempererat tali kepedulian dan persaudaraan antar umat.</p>
            </div>
          </div>
        </div>

        {/* Kontak & Lokasi */}
        <div className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm space-y-6">
          <h2 className="text-lg font-bold text-blue-900">Kantor Layanan & Kontak Resmi</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-slate-50/60 rounded-2xl p-4 border border-slate-200 space-y-1.5">
              <p className="text-xs font-bold text-blue-900 uppercase tracking-wider">Alamat Kantor</p>
              <p className="text-xs text-slate-600 leading-relaxed">
                Ruko Johar Grande, Jl. Johar Raya No.3, Kedung Waringin, Tanah Sareal, Bogor, Jawa Barat 16161
              </p>
            </div>
            <div className="bg-slate-50/60 rounded-2xl p-4 border border-slate-200 space-y-1.5">
              <p className="text-xs font-bold text-blue-900 uppercase tracking-wider">Kontak Support</p>
              <p className="text-xs text-slate-600">Email: <span className="font-semibold text-blue-900">support@dtpeduli.org</span></p>
              <p className="text-xs text-slate-600">WhatsApp: <span className="font-semibold text-blue-900">0823 1900 0200</span></p>
            </div>
            <div className="bg-slate-50/60 rounded-2xl p-4 border border-slate-200 space-y-1.5">
              <p className="text-xs font-bold text-blue-900 uppercase tracking-wider">Jam Operasional</p>
              <p className="text-xs font-semibold text-blue-900">Senin - Sabtu</p>
              <p className="text-xs text-slate-600">08:00 - 18:00 WIB</p>
            </div>
          </div>
        </div>

        {/* Daftar Donatur & Filter Lembaga */}
        {Array.isArray(data) && (
          <div className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm space-y-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h2 className="text-lg font-bold text-blue-900">Daftar Donatur Terdaftar</h2>
                <p className="text-xs text-slate-500 mt-0.5">Daftar donatur yang terhubung dalam ekosistem DT Peduli</p>
              </div>
              <div className="flex items-center gap-3">
                <select
                  value={selectedLembaga}
                  onChange={(e) => setSelectedLembaga(e.target.value)}
                  className="rounded-xl border border-blue-200 bg-slate-50 px-3 py-2 text-xs font-semibold text-blue-900 outline-none focus:border-blue-600"
                >
                  <option value="">Semua Lembaga</option>
                  {!lembagaLoading && !lembagaError && lembagaList && lembagaList.map((l) => (
                    <option key={l.id || l._id || l.id_lembaga} value={l.id || l._id || l.id_lembaga}>
                      {l.nama || l.name || `Lembaga ${l.id || l._id || l.id_lembaga}`}
                    </option>
                  ))}
                </select>
                <span className="text-xs font-bold bg-amber-100 text-amber-900 px-3 py-1.5 rounded-xl border border-amber-200 flex-shrink-0">
                  {data.length} Donatur
                </span>
              </div>
            </div>

            <div className="border border-slate-200 rounded-2xl overflow-hidden">
              {data.length > 0 ? (
                <div className="max-h-80 overflow-y-auto divide-y divide-slate-100 text-xs">
                  {data.map((donatur) => (
                    <div key={donatur.id} className="flex items-center justify-between px-5 py-3.5 hover:bg-slate-50 transition-colors">
                      <div>
                        <p className="font-bold text-blue-900">{donatur.nama || 'Donatur DT Peduli'}</p>
                        <p className="text-[11px] text-slate-500">{donatur.email || 'Email tidak terdaftar'}</p>
                      </div>
                      {donatur.nominal && (
                        <p className="font-bold text-amber-700">
                          Rp {Number(donatur.nominal).toLocaleString('id-ID')}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="p-8 text-center text-xs text-slate-500">
                  Belum ada data donatur untuk pilihan lembaga ini.
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default AboutUser;
